// import { useMutation, useQuery } from "@tanstack/react-query";
import { useSnackbar } from '../Stateless/SnackBarProvider';
import { useSubAdminApi } from '../../hooks/useSubAdminApi';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export const UseCreateSubAdmin = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { createSubAdmin } = useSubAdminApi();
  return useMutation({
    mutationKey: ['CreateSubAdmin'],
    mutationFn: (data: any) => createSubAdmin(data),
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'SubAdmin created successfully',
        'success'
      );
      queryClient.invalidateQueries({
        queryKey: ['getSubAdmin'],
        exact: false,
      });
    },

    onError: (error: any) => {
      showMessage(
        error.response?.data?.message || 'Failed to create SubAdmin',
        'error'
      );
    },
  });
};

export const usePatchSubAdmin = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { getToggleStatus } = useSubAdminApi();

  return useMutation({
    mutationKey: ['PatchSubAdmin'],
    mutationFn: ({ id, data }: { id: string[]; data: any }) =>
      getToggleStatus({ id, status: data.status }),
    onSuccess: (_response, variables) => {
      const action =
        variables.data.status === 'unblocked' ? 'unblocked' : 'blocked';
      showMessage(`Sub Admin ${action} successfully`, 'success');
      queryClient.invalidateQueries({
        queryKey: ['getSubAdmin'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.detail?.[0]?.type ||
          'Failed to block the SubAdmin',
        'error'
      );
    },
  });
};

export const useDeleteSubAdmin = () => {
  const queryClient = useQueryClient();
  const { deleteSubAdmin } = useSubAdminApi();
  const { showMessage } = useSnackbar();

  return useMutation({
    mutationKey: ['DeleteSubAdmin'],
    mutationFn: (ids: string[]) => {

      return deleteSubAdmin(ids);
    },
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'SubAdmin deleted successfully',
        'success'
      );
      queryClient.invalidateQueries({
        queryKey: ['getSubAdmin'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.message || 'Failed to deleted SubAdmin',
        'error'
      );
    },
  });
};

type Params = {
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  limit?: number;
  addedByFilter?: string;
  statusFilter?: string;
  search?: string;
};

export const useAllSubAdmin = (queryParams: Params) => {

  const { getAllSubAdmins } = useSubAdminApi();
  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: ['getSubAdmin', queryParams],
    queryFn: () => {
      return getAllSubAdmins(queryParams);
    },
  });

  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    refetch,
  };
};

export const useEditSubAdmin = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { editSubAdmin } = useSubAdminApi();

  return useMutation({
    mutationKey: ['EditSubAdmin'],
    mutationFn: ({ id, data }: { id: string; data: any }) =>
      editSubAdmin(id, data),
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'SubAdmin Updated successfully',
        'success'
      );
      queryClient.invalidateQueries({
        queryKey: ['getSubAdmin'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.detail?.[0]?.type ||
          'Failed to update the SubAdmin',
        'error'
      );
    },
  });
};
